export const isJsonPayload = (data) => Boolean(data) && typeof data === "object";
